import { createFileRoute, redirect } from "@tanstack/react-router";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/")({
  beforeLoad: () => {
    requireSuperAdmin()();
    throw redirect({ to: "/system/product-analytics/sessions" });
  },
});
